import clsx from 'clsx';
import React from 'react';

import styles from './Toggle.module.scss';

interface ToggleProps {
  isToggledDetailView: boolean;
  className?: string;
  handleToggle: () => void;
  dataTestId?: string;
}

export const Toggle: React.FC<ToggleProps> = ({ className, handleToggle, isToggledDetailView = false, dataTestId }) => (
  <label
    className={clsx(styles.switch, className)}
    data-testid={dataTestId}
  >
    <input
      type="checkbox"
      checked={isToggledDetailView}
      onChange={handleToggle}
    />
    <span className={clsx(styles.slider, styles.round)} />
  </label>
);
